// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TL9q","field":"styles_field__1s-uq","fieldCol":"styles_fieldCol__3PNyT","diffCol":"styles_diffCol__oh-Ov","diff":"styles_diff__3fN9_"};